import { EstimateurBudgetDetailPrix } from '@components/estimateur-budget-detail-prix/models';
import { Block } from '@shared/models';

export const estimateurBudgetDetailPrixMock: Block<EstimateurBudgetDetailPrix> = {
  type: 'estimateur-budget-detail-prix',
  data: {
    title: {
      text: `L'estimation de [[ma cuisine]]`,
      as: 'h1',
    },
    hideStartingPricePerMonth: false,
    rdv: {
      title: {
        text: `Besoin d'un \\\\[[devis détaillé ?]]`,
        as: 'span',
      },
      text: `Venez en magasin rencontrer nos concepteur afin qu’ils vous accompagne dans la création de votre cuisine et puisse vous fournir un devis en bonne et due forme.`,
      cta: {
        label: `Prendre rendez-vous`,
        url: '/mock-rendez-vous',
      },
    },
    gtmConfigCta: {
      event: 'click_cta_estimation_rdv',
      group: 'estimation',
      description: 'recap estimation',
      context: 'click bouton rdv tunnel estimation',
    },
  },
};
